/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {
    useContext, useCallback, useEffect
} from 'react';
import _ from 'lodash';
import { useModal } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useUpdateSubmissionServices, useCheckSubmissionVMDirty, validationUtil } from 'premier-capability-hooks';
import { withRouter } from 'react-router-dom';
import { PremierConstants } from 'premier-constant-service';
import presentationMetadata from "gw-capability-gateway-quoteandbind-PremierCT-react/config/PremierCT-wizard-config.json5";
// import { LoadSaveService } from 'gw-capability-quoteandbind';
import metadata from './EquipmentBreakdownPage.metadata.json5';
import messages from './EquipmentBreakdownPage.messages';
import styles from './EquipmentBreakdownPage.module.scss';
import CoveragesPageComponent from "../Coverages/CoveragesPage";
import RiskInformationComponent from '../../components/EquipmentBreakdown/RiskInformation/RiskInformationComponent';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function EquipmentBreakdownPage(props) {
    const {
        showConfirm
    } = useModal();

    const { wizardData: submissionVM, updateWizardData, currentStep, history, changeNextSteps, steps } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const translator = useTranslator();
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { updateSubmission } = useUpdateSubmissionServices();
    const jobNumber = submissionVM.value?.quoteID || submissionVM.value?.jobID;
    const { isDirty } = useCheckSubmissionVMDirty(submissionVM.value);
    const { lineName,jobTypes } = PremierConstants;
    const propertySteps = _.filter(_.get(presentationMetadata, [`${submissionVM.value.baseData.productCode}.default.wizard`, 'steps']), (wizardStep) => wizardStep.id.includes('property'))
    const { authHeader } = useAuthentication();
    const {
        onValidate,
        initialValidation,
        isComponentValid
    } = useValidation('EquipmentBreakdownPage');


    const onNext = useCallback(
        async () => {

            const {productCode} = submissionVM.value.baseData;
            const lobLineName = lineName[productCode];

            submissionVM.value = await updateSubmission(lobLineName, 'PropertyCoveragesPage', submissionVM);

            return submissionVM;
        },
        [submissionVM, updateSubmission]
    );

    const overrideProps = {
        
        riskInformation: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.consTraAndServLine.coverables.equipmentBreakdown.riskInformation"
        },
        
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            riskInformation: RiskInformationComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        [metadata.pageContent, submissionVM, overrideProps]
    );

    const onSave = useCallback(
        async () => {
            const subVMCopy = _.clone(submissionVM);
            const productCode = _.get(subVMCopy.value, 'baseData.productCode');
            
            validationUtil.unSetIsValidationReqFlag(subVMCopy?.lobData?.consTraAndServLine?.coverables?.equipmentBreakdown?.riskInformation?.value, ' ');

            const lobLineName = productCode ? lineName[productCode] : '';
            await updateSubmission(lobLineName, 'EquipmentBreakdownPage', subVMCopy);
                    
            return submissionVM;
        },
        [submissionVM]
    );

    const isDisableNext = () => !submissionVM?.lobData?.consTraAndServLine?.coverables?.equipmentBreakdown?.riskInformation?.aspects?.subtreeValid

    return (
        <WizardPage onNext={onNext} onSave={onSave} skipWhen={initialValidation} disableNext={isDisableNext()}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

EquipmentBreakdownPage.propTypes = wizardProps;
export default withRouter(EquipmentBreakdownPage);
